var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_c('b',[_vm._v(" Iklan")])]),_c('br'),(_vm.hits.id_mst_iklan_jenis == 1)?_c('PantauIB',{attrs:{"idIklan":_vm.idIklan}}):_vm._e(),(_vm.hits.id_mst_iklan_jenis == 2)?_c('PantauTB',{attrs:{"idIklan":_vm.idIklan}}):_vm._e(),(_vm.hits.id_mst_iklan_jenis == 5)?_c('PantauAS',{attrs:{"idIklan":_vm.idIklan}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }